import { render, staticRenderFns } from "./InvoiceEdit.vue?vue&type=template&id=5ffc9fed&scoped=true&"
import script from "./InvoiceEdit.vue?vue&type=script&lang=ts&"
export * from "./InvoiceEdit.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceEdit.vue?vue&type=style&index=0&id=5ffc9fed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffc9fed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCheckbox,VForm,VSelect})
